export default __webpack_public_path__ + "static/media/greenToolBox.7feed7a4.png";